export const LOGIN_USER = 'LOGIN_USER'
export const LOGIN_USER_JWT = 'LOGIN_USER_JWT'
export const FORGOT_PASSWORD = 'FORGOT_PASSWORD'
export const REQUEST_PASSWORD_RESET_OTP = 'REQUEST_PASSWORD_RESET_OTP'
export const VERIFY_PASSWORD_RESET_OTP = 'VERIFY_PASSWORD_RESET_OTP'
export const VERIFY_PASSWORD_RESET_GOOGLE = 'VERIFY_PASSWORD_RESET_GOOGLE'
export const RESET_PASSWORD = 'RESET_PASSWORD'
export const RESET_DEFAULT_PASSWORD = 'RESET_DEFAULT_PASSWORD'
export const LOGOUT_USER = 'LOGOUT_USER'
export const USER_ME = 'USER_ME'
export const VERIFY_LOGIN_CREDENTIALS = 'VERIFY_LOGIN_CREDENTIALS'
export const ADMISSION_LOGIN = 'ADMISSION_LOGIN'
export const LOGIN_WITH_GOOGLE = 'LOGIN_WITH_GOOGLE'
export const UNIVERSAL_LOGIN = 'UNIVERSAL_LOGIN'
export const UNIVERSAL_LOGIN_WITH_GOOGLE = 'UNIVERSAL_LOGIN_WITH_GOOGLE'
export const CHECK_INSTANCES = 'CHECK_INSTANCES'
